import e, { memo as g } from "react";
import { useTheme as w, AspectRatio as C, Image as E, Skeleton as b, Flex as n, Heading as y, Text as z } from "@chakra-ui/react";
import { Card as R, CardMedia as x, CardContent as H } from "../../atoms/card/card.js";
import { RichTextRenderer as T } from "../../atoms/rich-text-renderer/rich-text-renderer.js";
const j = (t) => typeof t == "object" ? /* @__PURE__ */ e.createElement(T, { content: t }) : t, k = g(
  ({
    title: t,
    altText: d,
    cardImage: c,
    cardContent: l,
    cardBgColor: m,
    cardMinWidth: s = "auto"
  }) => {
    const {
      cardContentSpacing: a,
      cardContentPadding: r,
      cardMiniInfoImage: i,
      element: h,
      cardHeadlineTablet: f,
      cardBodyTablet: p,
      cardHorizontalImageRadius: o
    } = w(), { spacingLarge: u } = h;
    return /* @__PURE__ */ e.createElement(
      R,
      {
        variant: "horizontal",
        width: "inherit",
        overflow: "hidden",
        minW: s,
        height: "100%",
        background: m,
        border: "none"
      },
      /* @__PURE__ */ e.createElement(
        x,
        {
          sx: {
            height: i,
            width: i,
            justifyContent: "center",
            marginLeft: r,
            my: r,
            border: "none",
            borderRadius: o,
            flex: "0"
          }
        },
        /* @__PURE__ */ e.createElement(C, { ratio: 1 / 1, width: "inherit", overflow: "hidden" }, /* @__PURE__ */ e.createElement(
          E,
          {
            fallback: /* @__PURE__ */ e.createElement(b, { "data-testid": "skeleton-image", w: "100%", minH: "100%" }),
            "data-testid": "mini-horizontal-feature-card-image",
            src: c,
            alt: d || "",
            loading: "lazy",
            height: "inherit",
            borderRadius: o
          }
        ))
      ),
      /* @__PURE__ */ e.createElement(H, { p: r }, /* @__PURE__ */ e.createElement(
        n,
        {
          direction: "row",
          h: "100%",
          justifyContent: "space-between",
          rowGap: a,
          flexWrap: "wrap"
        },
        /* @__PURE__ */ e.createElement(
          n,
          {
            direction: "column",
            rowGap: a,
            justifyContent: "center"
          },
          /* @__PURE__ */ e.createElement(
            y,
            {
              "data-testid": "mini-horizontal-feature-card-title",
              noOfLines: 2,
              as: "h3",
              ...f
            },
            j(t)
          ),
          /* @__PURE__ */ e.createElement(
            z,
            {
              "data-testid": "mini-horizontal-feature-card-content",
              ...p
            },
            l
          )
        ),
        /* @__PURE__ */ e.createElement(
          n,
          {
            direction: "row",
            rowGap: u,
            columnGap: a,
            justifyContent: "center",
            flexWrap: "wrap"
          }
        )
      ))
    );
  }
);
k.displayName = "HorizontalFeatureCardMini";
export {
  k as HorizontalFeatureCardMini
};
